import reactIcon from '../../../assets/icons/react.svg';
import nextIcon from '../../../assets/icons/nextjs.svg';
import angularIcon from '../../../assets/icons/angular.svg';
import vueIcon from '../../../assets/icons/vue.svg';
import nodeIcon from '../../../assets/icons/nodejs.svg';
import expressIcon from '../../../assets/icons/express.svg';
import dockerIcon from '../../../assets/icons/docker.svg';

export const skills = {
	title: 'Habilidades',
	titleLevel: 'Nível',
	list: [
		{
			id: 1,
			icon: reactIcon,
			link: 'https://pt-br.reactjs.org/',
			title: 'ReactJS',
			level: 'Avançado',
		},
		{
			id: 2,
			icon: reactIcon,
			link: 'https://reactnative.dev/',
			title: 'React Native',
			level: 'Intermediário',
		},
		{
			id: 3,
			icon: nextIcon,
			link: 'https://nextjs.org/',
			title: 'NextJS',
			level: 'Avançado',
		},
		{
			id: 4,
			icon: angularIcon,
			link: 'https://angular.io/',
			title: 'Angular',
			level: 'Básico',
		},
		{
			id: 5,
			icon: vueIcon,
			link: 'https://vuejs.org/',
			title: 'VueJS',
			level: 'Básico',
		},
		{
			id: 6,
			icon: nodeIcon,
			link: 'https://nodejs.org/en/',
			title: 'NodeJs',
			level: 'Intermediário',
		},
		{
			id: 7,
			icon: expressIcon,
			link: 'https://expressjs.com/pt-br/',
			title: 'Express',
			level: 'Básico',
		},
		{
			id: 8,
			icon: dockerIcon,
			link: 'https://www.docker.com/',
			title: 'Docker',
			level: 'Básico',
		},
	],
};
